import axios from 'axios'

const state = {
  data: {
    origin: null,
    destination: null,
    route: null
  },
  showSidebar: false,
  ready: false
}

const getters = {
  route: state => {
    return state
  }
}

const mutations = {
  SET_ROUTE(state, route) {
    state.data.route = route
    state.ready = true
    state.show = true
  },
  CLEAR_ROUTE_STORE(state) {
    state.data =  {
      origin: null,
      destination: null,
      route: null
    }
    state.ready = false
    state.show = false
  },
  TOGGLE_SIDEBAR(state){
    state.showSidebar = !state.showSidebar;
  },
  SHOW_SIDEBAR(state){
    state.showSidebar = true;
  },
  HIDE_SIDEBAR(state){
    state.showSidebar = false;
  }
}


const actions = {
  setRoute: ({commit}, route) => {
    commit('SET_ROUTE', route)
  },
  clearRouteStore: ({commit}) => {
    commit('CLEAR_ROUTE_STORE')
  },
    toggleSidebar: ({commit}) => {
        commit('TOGGLE_SIDEBAR')
    },
  closeSidebar: ({commit}) => {
    commit('HIDE_SIDEBAR')
  }
}

export default {
  state, mutations, getters, actions
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScript/store/routeStore.js